import { postRequest } from '../../../shared/utils';

export async function getFormOrderDropDown(screenGridId, configSchema, formOrderWhere) {
  const body = {
    columns: ['form_order_no'],
    screenGridId,
    schema: configSchema,
    table: 'mbd_screen_grid_attribute_config',
    filterModel: formOrderWhere,
    orderCol: 'form_order_no',
    order: 'asc',
  };
  const { errors, data } = await postRequest('/api/records', body);
  if (errors) {
    return { errors };
  }
  return data[configSchema + '_mbd_screen_grid_attribute_config'];
}
